/* eslint-disable @typescript-eslint/no-var-requires */
const {
    brandsConfig,
}: { brandsConfig: BrandsConfig } = require('@ringcentral/rwc-branding/src/brand-config');

type ID = string;
type BrandCodes = { [name: string]: ID };
type DomainToBrandIdMap = { [domain: string]: ID };
type BrandsConfig = {
    [name: string]: {
        id: ID;
        proDomain: string;
        opsDomain: string;
    };
};

export const ProDomainMap: DomainToBrandIdMap = Object.fromEntries(
    Object.values(brandsConfig).map(value => [value.proDomain, value.id])
);
const OpsDomainMap: DomainToBrandIdMap = Object.fromEntries(
    Object.values(brandsConfig).map(value => [value.opsDomain, value.id])
);

export const DomainBrandIdMap: DomainToBrandIdMap = { ...ProDomainMap, ...OpsDomainMap };

export const BrandCodeToBrandIdMap: BrandCodes = Object.fromEntries(
    Object.entries(brandsConfig).map(([key, value]) => [key, value.id])
);
